import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@workboard/wobo-ui';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';
import TeamSettingsAdminPage from './TeamSettingsAdminPage';

declare global {
  interface Window {
    initTeamSettingsAdminPage: (orgId: number, container: HTMLElement) => void;
  }
}

export interface TeamSettingsAdminProps {
  orgId: number;
}

export const initTeamSettingsAdminPage = (
  orgId: number,
  container: HTMLElement,
): void => {
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider>
            <TeamSettingsAdminPage orgId={orgId} />
          </ThemeProvider>
        </I18nextProvider>
      </React.StrictMode>,
    );
  } else {
    console.error('Team Settings Admin container not found');
  }
};

// Expose function globally
window.initTeamSettingsAdminPage = initTeamSettingsAdminPage;

export default initTeamSettingsAdminPage;
